// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

/** TV (media). */
const icon: IconData = {
  id: "tv",
  name: "TV",
  category: "media",
  styles: {
    rounded: {
      svg: '<path d="M17.95 2.46L15.41 5H21.01L21.39 5.08 21.71 5.29 21.92 5.61 22 6V20L21.92 20.39 21.7 20.71 21.39 20.92 21.01 21H2.99L2.61 20.92 2.29 20.71 2.07 20.38 2 20V6L2.08 5.61 2.29 5.29 2.61 5.08 2.99 5H8.59L6.05 2.46 7.46 1.05 11.41 5H12.59L16.54 1.05ZM4.6 7L4.37 7.05 4.18 7.18 4.05 7.37 4 7.6V18.4L4.05 18.63 4.18 18.82 4.37 18.95 4.6 19H19.4L19.63 18.95 19.82 18.82 19.95 18.63 20 18.4V7.6L19.95 7.37 19.82 7.18 19.63 7.05 19.4 7ZM18.71 8.29L18.8 8.5V17.5L18.71 17.71 18.5 17.8H5.5L5.29 17.71 5.2 17.5V8.5L5.29 8.29 5.5 8.2H18.5Z"/>',
    },
    sharp: {
      svg: '<path d="M17.95 2.46L15.41 5H21.01L21.39 5.08 21.71 5.29 21.92 5.61 22 6V20L21.92 20.39 21.7 20.71 21.39 20.92 21.01 21H2.99L2.61 20.92 2.29 20.71 2.07 20.38 2 20V6L2.08 5.61 2.29 5.29 2.61 5.08 2.99 5H8.59L6.05 2.46 7.46 1.05 11.41 5H12.59L16.54 1.05ZM4 7V19H20V7ZM18.8 17.8H5.2V8.2H18.8Z"/>',
    },
    outline: {
      svg: '<path d="M15.41 5H21C21.55 5 21.99 5.45 21.99 6V20C21.99 20.55 21.53 21 21 21H2.99A.99.99 0 0 1 2 20V6C2 5.45 2.46 5 2.99 5H8.58L6.05 2.46 7.46 1.05 11.41 5H12.58L16.53 1.05 17.94 2.46ZM4 7V19H20V7Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M17.94 2.46L15.41 5H21L21.39 5.08 21.7 5.29 21.91 5.61 21.99 6V20L21.91 20.39 21.69 20.71 21.38 20.92 21 21H2.99L2.61 20.92 2.29 20.71 2.07 20.38 2 20V6L2.08 5.61 2.3 5.29 2.61 5.08 2.99 5H8.58L6.05 2.46 7.46 1.05 11.41 5H12.58L16.53 1.05Z"/></g><path d="M15.41 5H21C21.55 5 21.99 5.45 21.99 6V20C21.99 20.55 21.53 21 21 21H2.99A.99.99 0 0 1 2 20V6C2 5.45 2.46 5 2.99 5H8.58L6.05 2.46 7.46 1.05 11.41 5H12.58L16.53 1.05 17.94 2.46ZM4 7V19H20V7Z"/>',
    },
  },
  animation: () => import("../animations/tv.js"),
};

export default icon;
